import { useEffect, useState } from "react";
import { IPaginationProps } from "./Pagination.props";
import {
  DEFAULT_PAGE,
  DEFAULT_PAGE_SIZE,
} from "@components/Pages/Machines/MinersTable/useMinersTableControl";

export const usePaginationControl = <T>(props: IPaginationProps<T>) => {
  const {
    page,
    pageSize: pgsz,
    total,

    getPage,
  } = props;

  const [pageSize, setPageSize] = useState<number>(pgsz || DEFAULT_PAGE_SIZE);
  const [currentPage, setCurrentPage] = useState<number>(page || DEFAULT_PAGE);

  useEffect(() => {
    if (!getPage) return;
    getPage(currentPage, pageSize);
  }, [currentPage, pageSize]);

  useEffect(() => {
    setCurrentPage(page || currentPage);
  }, [page]);

  useEffect(() => {
    setPageSize(pgsz || DEFAULT_PAGE_SIZE);
  }, [pgsz]);

  return {
    total,
    pageSize,
    currentPage,

    setPageSize,
    setCurrentPage,
  };
};
